<div class='admissions-engagements-page'>

	<toolbar icon='Admissions'>

		<button class="btn btn-light" (click)='admissionsService.reloadData()' KendoTooltip [attr.title]="'Reload'"><i
				class='far fa-sync-alt' style="display: inline-block;width: 1.5em;"></i></button>

		<droplist [items]='[]' [popupConfig]='popupConfig' [navigation]='true'>
		</droplist>

		<div style='display:inline-block;width:300px'>
			<trimester-droplist [trimesterWindow]="trimesterWindow"></trimester-droplist>
		</div>

	</toolbar>

	<page-tabs [tabNames]='["Engagements", "Staff", "Tab2"]' [pageService]='pageService'
		(layoutChange)='onLayoutChange($event)'>
		<ng-template pageTab1>
			<admissions-engagements-views-part></admissions-engagements-views-part>
		</ng-template>

		<ng-template pageTab2>
			<admissions-engagements-tab-1-part></admissions-engagements-tab-1-part>
		</ng-template>

		<ng-template pageTab3>
			<admissions-engagements-tab-2-part></admissions-engagements-tab-2-part>
		</ng-template>
	</page-tabs>

</div>